var React = require('react');

function Store (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","fill":"none","d":"M21.502 10.333v12.167h-19v-12.187","key":0}),React.createElement("path",{"stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","fill":"none","d":"M4.502 13.5h8v6h-8zM14.502 13.5h5v9h-5zM21.502 2.5h-19l-2 4h23zM23.502 7.5c0 1.657-1.343 3-3 3-.826 0-1.457-.46-2-1-.708 1.125-2.073 2-3.5 2-1.196 0-2.267-.528-3-1.36-.732.833-1.804 1.36-3 1.36-1.427 0-2.792-.875-3.5-2-.542.54-1.174 1-2 1-1.657 0-3-1.343-3-3v-1h23v1zM5.502 9.5v-3l1-4M12.002 10.146v-7.646M18.502 9.5v-3l-1-4","key":1}),React.createElement("path",{"d":"M17.502 18c-.276 0-.5.224-.5.5 0 .277.224.5.5.5s.5-.223.5-.5c0-.276-.224-.5-.5-.5z","key":2})]));
}

Store.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Store;

Store.default = Store;
